import { projectsRemoveTokensReducer } from '@slices/projects/projects-remove-tokens';
import { projectsSelectProjectReducer } from '@slices/projects/projects-select-project';
import { projectsSetTokensReducer } from '@slices/projects/projects-set-tokens';

import { REACT_APP_WEB_API_URL } from '@config/env';

import { appCreateSlice } from '@store/rtk';

import { ProjectsState } from './types';

export const projectsDefaultState: ProjectsState = {
  currentProject: undefined,
  currentProjectWebApiUrl: REACT_APP_WEB_API_URL,
  currentProjectAdminApiUrl: undefined,
  projects: [],
};

export const projectsSlice = appCreateSlice({
  name: 'projects',
  initialState: projectsDefaultState,
  reducers: {
    projectsSetTokens: projectsSetTokensReducer,
    projectsRemoveTokens: projectsRemoveTokensReducer,
    projectsSelectProject: projectsSelectProjectReducer,
  },
});

export const {
  actions: { projectsSetTokens, projectsRemoveTokens, projectsSelectProject },
  reducer: projectsReducer,
} = projectsSlice;
